import { TableWithPagination } from "shared/Components/tableWithPagination/index.js";
import CustomDatePicker from "shared/Components/datepicker";
import { download } from "helper/icons";
import { globalClasses } from "helper/globalClasses";
import { globalVariables } from "helper/globalVariables";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from 'react-router-dom';
// Removed ListMobileTable - now always showing table view with horizontal scroll
// import { ListMobileTable } from "./Components/ListMobileTable";
import { useLazyQuery } from "@apollo/client";
import { SearchLocation } from "shared/Components/searchLocation";
import { TrialCalendarQuery } from "redux/features/trialCalendar/trialCalendarGql";
import moment from "moment";
import { useEffect, useState } from "react";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import useEffectAfterMount from "helper/useEffectAfterMount";
import { MultiSelectChipsWithSearchDropdown } from "shared/Components/multiSelectWithSearchAndChips";
import { CustomDateRangePicker } from "shared/Components/customDateRangePicker";
import PageInfo from "shared/Components/pageInfo";
import { Button } from "shared/Components/button";
import ScrollToTop from "shared/Components/scrollToTop";

const { paginatedDataCls } = globalClasses;

const headData = [
  {
    label: globalVariables.date,
    style: "",
  },
  {
    label: globalVariables.name,
    style: "",
  },
  {
    label: globalVariables.city,
    style: "",
  },
  {
    label: globalVariables.state,
    style: "",
  },
  {
    label: globalVariables.host,
    // style: "pl-0 !text-left",
  },
  {
    label: globalVariables.status,
    style: "",
  },
  // {
  //   label: globalVariables.location,
  //   style: "pl-0 !text-left",
  // },
  // {
  //   label: globalVariables.level,
  //   style: "pl-0 !text-left",
  // },

  {
    label: globalVariables.openDate,
    style: "",
  },
  {
    label: globalVariables.closeDate,
    style: "",
  },
  {
    label: globalVariables.cutoffDate,
    style: "",
  },
  {
    label: globalVariables.trialPremium,
    style: "",
  },
];

const noviceDropdownData = [
  globalVariables.sit,
  globalVariables.novice,
  globalVariables.advanced,
  globalVariables.excellent,
  globalVariables.premier,
];

export const TrialCalendar = () => {
  const navigate = useNavigate();
  const isTabletMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const [page, setPage] = useState(1);
  // Removed isMobile check - always show table view with horizontal scroll
  // const isMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const [cityFilter, setCityFilter] = useState(null);
  const [stateFilter, setStateFilter] = useState(null);
  const [levelFilter, setLevelFilter] = useState([]);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const options = noviceDropdownData.map((data, index) => ({
    label: data,
    value: `option_${index}`,
  }));

  const handleFilterChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.label);
    setLevelFilter(selectedValues);
  };

  const [getData, { loading, error, data }] = useLazyQuery(TrialCalendarQuery, {
    fetchPolicy: "no-cache",
  });
  const resultData = data?.getAllTrialCalendar;
  
  const trials = resultData?.data || [];

  useEffect(() => {
    getData({
      variables: {
        pageNumber: page,
        approvalStatus: "Approve",
        pageSize: 10,
        role: "Member",
        level: levelFilter.length === 0 ? null : levelFilter,
        city: cityFilter,
        state: stateFilter,
        trialResult: false,
        fromDate: date.startDate
          ? moment(date.startDate).format("yyyy-MM-01")
          : null,
        toDate: date.endDate ? moment(date.endDate).format("yyyy-MM-31") : null,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffectAfterMount(() => {
    getData({
      variables: {
        pageNumber: page,
        approvalStatus: "Approve",
        pageSize: 10,
        role: "Member",
        level: levelFilter.length === 0 ? null : levelFilter,
        city: cityFilter,
        state: stateFilter,
        trialResult: false,
        fromDate: date.startDate
          ? moment(date.startDate).format("yyyy-MM-01")
          : null,
        toDate: date.endDate ? moment(date.endDate).format("yyyy-MM-31") : null,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [levelFilter, cityFilter, stateFilter, date.startDate, date.endDate, page]);


  const handlePaginationData = (page = 1, size = 10) => {
    setPage(page);
  };

  const handleDownloadIconClick = (e) => {
    e.stopPropagation();
  };

  const renderTableBody = () =>
    trials.map((trial, index) => {
      return (
        <tr
        className={`cursor-pointer
          ${
            trial?.trial?.status == "Open"
              ? "bg-lightGreen"
              : trial?.trial?.status == "Close"
              ? "bg-lightRed"
              : ""
          }`}
          key={trial.date}
          onClick={() => navigate(`/dashboard/trialDetails/${trial.id}`)}
        >
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {moment.utc(trial?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {trial?.trial?.trialName || "-"}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial?.city}
          </td>
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {trial?.trial?.state}
          </td>

          {/* <td className={`${paginatedDataCls(index)} !text-left !pl-0`}>
            {trial?.trial?.trialLocationAddress}
          </td> */}
          {/* <td className={`${paginatedDataCls(index)} !text-left !pl-0`}>
            {trial?.search?.length > 0
              ? trial?.search?.map((search) => search?.level)?.join(", ")
              : "NA"}
          </td> */}
          <td className={`${paginatedDataCls(index, "min-w-[150px]")}`}>
            {trial.host?.hostName}
          </td>
          <td className={paginatedDataCls(index)}>
            <span
              className={`
                ${
                  trial?.trial?.status == "Open"
                    ? "text-green font-semibold"
                    : trial?.trial?.status == "Close"
                    ? "text-red font-semibold"
                    : ""
                }`}
            >
              {trial?.trial?.status == "Close" ? "Closed" : trial?.trial?.status}
            </span>
          </td>
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
              {moment.utc(trial?.trial?.openDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {moment.utc(trial?.trial?.closeDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {trial?.trial?.cutoffDate ? moment.utc(trial?.trial?.cutoffDate).format(DEFAULT_DATE_FORMAT) : "-"}
          </td>
          <td
            className={paginatedDataCls(index)}
            onClick={handleDownloadIconClick}
          >
            {
              trial?.trial?.trialFile ? 
            <a href={trial?.trial?.trialFile} target="_blank" rel="noreferrer">
              <img src={download} alt="" className="mx-auto" />
            </a>
            : <p>N/A</p>
            }
          </td>
        </tr>
      );
    });

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #ccc",
      width: "220px",
      borderRadius: "6px",
      backgroundColor: "#ffffff80",
      minHeight: "44px",
      boxShadow: state.isFocused ? "0 0 0 1px #007bff" : null,
      "&:hover": {
        borderColor: "#007bff",
      },
    }),
  };

  const onClearFilters = () => {
    setDate({
      startDate: null,
      endDate: null,
    });
    setCityFilter(null);
    setStateFilter(null);
    setLevelFilter([]);
  };

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <ScrollToTop />
      <PageInfo title={globalVariables.trialCalendar}>
        <Button
          width={"w-auto"}
          label="Clear All Filters"
          onClick={onClearFilters} 
        />
      </PageInfo>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
        <CustomDateRangePicker
          defaultStartDate={date.startDate}
          defaultEndDate={date.endDate}
          isNavigation
          isShadow={true}
          width={"w-full"}
          onSetDate={(startDate, endDate) => {
            setDate({
              ...date,
              startDate: startDate ? new Date(startDate) : null,
              endDate: endDate ? new Date(endDate) : null,
            });
          }}
          />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="State"
          placeholder={globalVariables.state}
          types={["(regions)"]}
          onSelectLocation={(location) => {
            setStateFilter(location ?? null);
          }}
          defaultValue={stateFilter}
        />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="city"
          placeholder={globalVariables.city}
          types={["(cities)"]}
          onSelectLocation={(location) => {
            setCityFilter(location ?? null);
          }}
          defaultValue={cityFilter}
          searchBy={stateFilter}
        />
        <MultiSelectChipsWithSearchDropdown
          width={"w-full z-10"}
          placeholder={globalVariables.level}
          options={options}
          label=""
          onChange={handleFilterChange}
          defaultSelectedOptions={levelFilter}
        />
    </div>
      {/* Always show table view with horizontal scroll on mobile */}
      <div className="mt-6 pb-8 overflow-x-auto">
        <TableWithPagination
          headData={headData}
          headDateWithStyle={true}
          tableHeight={`${isTabletMobile ? "h-[85vh]" : "h-[600px]"}`}
          tableBody={renderTableBody()}
          itemsPerPage={10}
          totalPage={resultData?.totalPages}
          handlePageChange={(page) => handlePaginationData(page)}
          loading={loading}
          current={page}
          error={error}
          persistPagination={true}
        />
      </div>
    </div>
  );
};
